<template>
  <div class="meeting">
    <div class="top">
      <h2>类型：</h2>
      <span class="active">课程</span>
    </div>
    <div class="list-box">
      <Item v-for="item in list" :key="item.articleId" :details="item"> </Item>
    </div>
    <Paging
      :total="total"
      :curPage="curPage"
      :limit="limit"
      :showPage="6"
      @changePager="handlePager"
    ></Paging>
  </div>
</template>

<script>
import Item from "@/components/pager/courseItme";
import Paging from "@/components/paging";
export default {
  components: {
    Item,
    Paging,
  },
  data() {
    return {
      list: [],
      // 分页
      curPage: 1,
      total: 0,
      limit: 0,
    };
  },
  created() {
    this.getUserCollectCurriculumList();
  },
  methods: {
    // 分页
    handlePager(newPage) {
      this.curPage = newPage;
      this.getUserCollectCurriculumList();
      document.documentElement.scrollTop = 0;
    },
    async getUserCollectCurriculumList() {
      const resp = await this.$apis.userServe.getUserCollectCurriculumList({
        pageSize: 6,
        pageNo: this.curPage,
      });
      if (resp.data) {
        this.total = +resp.data.total;
        this.limit = +resp.data.pageSize;
        this.list = resp.data.list;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.meeting {
  width: 1200px;
  .top {
    display: flex;
    margin: 40px 0;
    h2 {
      vertical-align: middle;
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    span {
      margin: 0 10px;
      cursor: pointer;
      &.active {
        color: #0101f3;
      }
    }
  }
  .list-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &:after {
      content: "";
      width: 380px;
    }
  }
}
</style>